export default __webpack_public_path__ + "static/media/LogoAMD_2.0a809ffb.png";